/**
 * Citizens Information brand favicon and title management
 * Self-contained - no knowledge of other brands
 */

import faviconUrl from './favicon.ico';

function setBrandFavicon() {
  let faviconLink = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
  
  // Create favicon link if it doesn't exist
  if (!faviconLink) {
    faviconLink = document.createElement('link');
    faviconLink.rel = 'icon';
    faviconLink.type = 'image/x-icon';
    document.head.appendChild(faviconLink);
  }
  
  faviconLink.href = faviconUrl;
}

function setBrandTitle(customTitle?: string) {
  const baseTitle = 'AskCI Admin - Citizens Information Board';
  document.title = customTitle ? `${customTitle} | ${baseTitle}` : baseTitle;
}

export function setBrandAssets(customTitle?: string) {
  setBrandFavicon();
  setBrandTitle(customTitle);
}
